/** @format */

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
	selectAllProductSkusPartNumber,
	selectResolvedSkuPartNumber
} from '@pdp/data-access/state';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { ProductAnalyticsService } from '@shared/data-access/services';
import { WINDOW } from '@shared/utils/services';
import { ATC_BUTTON_TEXTS } from '@pdp/add-to-cart/data-access';

@Component({
    selector: 'pdp-add-to-cart-see-available-stores-button',
    templateUrl: './see-available-stores-button.component.html',
    styleUrl: './see-available-stores-button.component.scss',
    imports: [CommonModule, HmfButtonComponent]
})
export class SeeAvailableStoresButtonComponent implements OnInit, OnDestroy {
	productSkusPartNumber: string[] = [];
	resolvedSkuPartNumber: string;
	isErrorOnAttributes = false;
	atcButtonTexts = ATC_BUTTON_TEXTS;

	private UNSUBSCRIBE$: Subject<void> = new Subject();

	constructor(
		public store: Store,
		@Inject(WINDOW) protected window: Window,
		private productAnalyticsService: ProductAnalyticsService
	) {}

	ngOnInit() {
		this.store
			.select(selectAllProductSkusPartNumber)
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((value) => {
				if (value) {
					this.productSkusPartNumber = value;
				}
			});
		this.store
			.select(selectResolvedSkuPartNumber)
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((value) => {
				this.resolvedSkuPartNumber = value;
				if (value) {
					this.isErrorOnAttributes = false;
				}
			});
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	openChangeStorePanel() {
		const storeSelectionValues = this.resolvedSkuPartNumber
			? { skusArr: this.productSkusPartNumber, selectedSkuVal: this.resolvedSkuPartNumber }
			: { skusArr: this.productSkusPartNumber };
		this.window.headerFunctions.storeSelection(storeSelectionValues);
		this.productAnalyticsService.triggerDataEmCall('PDP_seeAvailableStores_button');
	}
}



